import React from "react";

import {
  Button,
  Card,
  CardBody,
  Form,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";

import SweetAlert2 from "react-sweetalert2";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Header from "components/Headers/Header.js";
import Api from "shared/resources/Api";

export default class imobiliariaList extends React.Component {
  /* Dados Grid */
  columns = [

    {
      name: "Imobiliária",
      selector: "ds_nome",
      sortable: true,
    },
    {
      name: "Descricao",
      selector: "ds_descricao",
      sortable: true,
    },
    {
      name: 'Status',
      cell: (row) => (
        <div>
          {row.tp_ativo && row.tp_ativo.toLowerCase() === 's' ? 'Ativo' : row.tp_ativo && row.tp_ativo.toLowerCase() === 'n' ? 'Inativo' : ''}
        </div>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <div>
          <Button
            type="button"
            className="btn-acao "
            title="Editar"
            onClick={() => {
              this.props.history.push("/admin/imobiliaria-edit", {
                imobiliaria: row,
              });
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
          </Button>
          {/* {localStorage.getItem("perm") === "coordenador" && (
            <Button
              type="button"
              className="btn-acao "
              title="Remover"
              onClick={() => {
                this.handleDelete(row);
              }}
            >
              <FontAwesomeIcon icon={faTrashAlt} className="remove" />
            </Button>
          )} */}
        </div>
      ),
    },
  ];
  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };
  customStyles = {
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {     
      api: Api.baseURL,
      requesting: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillMount() {
    try {
      let params = {
      };
     

      let esc = encodeURIComponent;
      let query = Object.keys(params)
        .map((k) => esc(k) + "=" + esc(params[k]))
        .join("&");
  
      let host = this.state.api + "/imobiliaria?";
  
      const response = fetch(host + query, {
        headers: {
          Authorization: localStorage.getItem("agToken"),
        },
      }).then((respons2) => {
        if (!respons2.ok) {
          throw new Error("Network response was not ok");
        }
        return respons2.json();
      })
      .then((body) => {
        console.log("body"+body)
        localStorage.setItem("imobiliaria", JSON.stringify(body));
        var obj2 = JSON.parse(localStorage.getItem("imobiliaria"));
        this.setState({
          response: obj2,
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      }); 
    } catch (e) {
      console.error("Invalid JSON string:", e);
    }

    document.addEventListener("keydown", (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.handleSubmit(event);
      }
    });
  }

  handleDelete = (element) => {
    this.setState({
      swal: {
        show: true,
        title: "Atenção",
        text: "Deseja realizar a exclusão da imobiliária?",
        type: "warning",
        showCancelButton: true,
        showConfirmButton: true,
      },
      sketch: element,
      isConfirmation: true,
    });
  };
  handleDeleteSketch(d) {
    this.callDelSketch(d)
      .then()
      .catch((err) => console.log(err));
  }

  callDelSketch = async (d) => {
    const response = await fetch(Api.baseURL + "/imobiliaria/" + d.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        swal: {
          show: true,
          title: "Tudo Certo",
          text: "Imobiliária excluída com sucesso!",
          type: "success",
        },
        cod_bairro: "",
        bairro: "",
        selectedNeighborhood:"",
        response: "",
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Erro ao deletar Imobiliária.",
          type: "error",
        },
      });

      throw Error(body.message);
    }

    return body;
  };

  handleSubmit(event) {
    this.setState({ requesting: true });
    this.fetchSketch()
      .then((res) => this.setState({ response: res }, () => {
        localStorage.setItem("imobiliaria", JSON.stringify(res));
      }))
      .catch((err) => console.log(err));

    event.preventDefault();
  }

  fetchSketch = async () => {
    let params = {
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    let host = this.state.api + "/imobiliaria?";

    const response = await fetch(host + query, {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (body.length > 0) {
      this.setState({
        sketch: body,
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Não foram encontrados croquis para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }

    return body;
  };

  render() {
    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });

            if (this.state.isConfirmation && !result.dismiss) {
              this.setState({
                isConfirmation: false,
              });
              this.handleDeleteSketch(this.state.sketch);
            }
          }}
        />
        <Header />

        {/* Page content */}
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Imobiliárias
                    </h6>

                    <div className="text-center">
                      <Row>
                        <Col className="order-xl-1" xl="12">
                          {localStorage.getItem("perm") === "coordenador" && (
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="button"
                              onClick={() => {
                                this.props.history.push(
                                  "/admin/imobiliaria-edit"
                                );
                              }}
                            >
                              <b>Cadastrar</b>
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.response && !this.state.requesting && (
            <DataTable
              noHeader={true}
              pagination={true}
              striped={true}
              columns={this.columns}
              sortable={true}
              responsive={true}
              highlightOnHover={true}
              data={this.state.response}
              noDataComponent="Nenhum registro encontrado."
              paginationComponentOptions={this.defaultComponentOptions}
              customStyles={this.customStyles}
            />
          )}
          {this.state.requesting && (
            <div className="text-center">
              <Spinner
                style={{ width: "3rem", height: "3rem" }}
                color="primary"
              />
            </div>
          )}
        </Container>
      </>
    );
  }
}
